module.exports = __webpack_public_path__ + "../resources/images/illustration_to_me-f10b59d7b6c6762187b87046374ebc72.svg";